import React from 'react';
import './LeaderboardButton.css';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';

const LeaderboardButton = ({ onLeaderboard }) => {
  return (
    <button
      className="leaderboard-button"
      onClick={onLeaderboard}
    >
      <LeaderboardIcon sx={{ fontSize: 20 }} />
    </button>
  );
};

export default LeaderboardButton; 